export class Helper {

	public static formatCpfCnpj(str: string): string {
		if (str.length === 11) {
			return str.substring(0, 3).concat('.')
				.concat(str.substring(3, 6))
				.concat('.')
				.concat(str.substring(6, 9))
				.concat('-')
				.concat(str.substring(9, 11));
		} else if (str.length === 14) {
			return str.substring(0, 2).concat('.')
			.concat(str.substring(2, 5))
			.concat('.')
			.concat(str.substring(5, 8))
			.concat('/')
			.concat(str.substring(8, 12))
			.concat('-')
			.concat(str.substring(12, 14));
		}

		return str;
	}

	public static formatPhone(str: string): string {
		return str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	}

	public static removeCnpjCharacters(cpfCnpj: string): string {
		return cpfCnpj.replace('-' , '').replace('.' , '').replace('/' , '');
	}

	public static maskCpfCnpj(str: string): string {
		if (str.length === 0) {
			return '';
		} else if (str.length <= 3) {
			return str.replace(/^(\d{0,3})/, '$1');
		} else if (str.length <= 6) {
			return str.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
		} else if (str.length <= 9) {
			return str.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3');
		} else if (str.length <= 11) {
			return str.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
		} else if (str.length <= 12) {
			return str.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3/$4');
		} else if (str.length <= 14) {
			return str.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, '$1.$2.$3/$4-$5');
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/helper.ts